/**
 * Link direto para uma tarefa (/?tarefa=<id>), usado nos cartões do Teams. Se a pessoa ainda não
 * entrou, o id fica guardado na aba durante o login com a Microsoft e a tarefa abre na volta.
 */
const KEY = 'quadro:tarefa';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Na tela de login: guarda o id para depois do retorno da Microsoft. */
export function stashTaskLink() {
  const id = new URLSearchParams(location.search).get('tarefa');
  if (id && UUID.test(id)) try { sessionStorage.setItem(KEY, id); } catch { /* sem storage: abre o quadro */ }
}

/** No app: o id pedido (da URL ou guardado no login), limpando os dois. */
export function takeTaskLink(): string | null {
  const params = new URLSearchParams(location.search);
  let id = params.get('tarefa');
  if (id) {
    params.delete('tarefa');
    const qs = params.toString();
    history.replaceState(history.state, '', location.pathname + (qs ? `?${qs}` : '') + location.hash);
  }
  try {
    id ??= sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch { /* sem storage */ }
  return id && UUID.test(id) ? id : null;
}
